import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { pipe, Subject, takeUntil } from 'rxjs';
import { QuotationStatusMaster, QuotationSummaryUploaded } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { UploadedDocPopupComponent } from '../uploaded-doc-popup-quotation/uploaded-doc-popup.component';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { QuotationSummaryService } from 'src/app/_Services/quotationNew/quotationsummary.service';
import { InvoiceSummaryService } from 'src/app/_Services/invoice/invoice-summary.service';
import { InvoiceChangeStatusRequest, InvoiceStatusMaster } from 'src/app/_Models/invoice/invoice-summary.model';

@Component({
  selector: 'app-invoice-accept-design-popup',
  templateUrl: './accept-invoice-design-popup.component.html',
  styleUrls: ['./accept-invoice-design-popup.component.scss']
})
export class AcceptInvoiceDesignPopupComponent implements OnInit, OnDestroy {

  @Input() data!: any;
  @Output() refreshdata = new EventEmitter<any>();
  public model: InvoiceChangeStatusRequest;
  public isLoading: boolean = false;
  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    private modalService: NgbModal,
    public quService: InvoiceSummaryService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.model = new InvoiceChangeStatusRequest();
    this.model.invoiceId = this.data.id;
    this.model.statusId = InvoiceStatusMaster.Approved;
  }

  cancelClicked() {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(UploadedDocPopupComponent, { centered: true, windowClass: 'document-popup-wrapper certifcate-view-popup' });
    modalRef.componentInstance.data = this.data;   // pass data to popup

    modalRef.componentInstance.setPdf(this.data.invoiceFileUrl);
  }

  saveApproveQuotation() {
    this.isLoading = true;
    this.quService.updateInvoiceStatus(this.model)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (response) {
            if (response && response.result == 1) {
              // Show success toaster
              this.toastr.success(
                this.translate.instant('Invoice approved successfully')
              );

              // Close modal and refresh page to show updated data
              // setTimeout(() => {
              //   this.modalService.dismissAll();
              //   // Refresh the page to show updated data
              //   window.location.reload();
              // }, 1500);
               this.refreshdata.emit();
            } else {
              this.toastr.error(
                this.translate.instant('Failed to approve invoice')
              );
            }
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error(
            this.translate.instant('An error occurred while approving the invoice')
          );
          console.error('Approval error:', error);
        }
      );
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
